module.exports = {
      id: "launcher-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#launcher",
      toString: function () {
        return this.url;
      }
    }